var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39247 15.7122C1.14119 15.9635 1 16.3044 1 16.6598C1 17.0153 1.14116 17.3561 1.39244 17.6075C1.64379 17.8588 1.98473 18 2.34014 18C2.69555 18 3.03642 17.8588 3.28777 17.6076L9.50613 11.3892L15.7244 17.6075L15.7285 17.6115C15.9813 17.8556 16.3198 17.9908 16.6713 17.9877C17.0227 17.9846 17.3589 17.8437 17.6074 17.5952C17.8559 17.3466 17.9969 17.0105 18 16.6591C18.003 16.3076 17.8679 15.969 17.6238 15.7163L17.6198 15.7122L11.4015 9.49387L17.6198 3.27557L17.6238 3.27152C17.8679 3.01872 18.003 2.68014 18 2.32871C17.9969 1.97727 17.8559 1.6411 17.6074 1.39258C17.3589 1.14407 17.0227 1.00311 16.6713 1.00005C16.3198 0.996999 15.9813 1.1321 15.7285 1.37625L15.7244 1.38023L9.50613 7.59853L3.2878 1.38023L3.28375 1.37625C3.03096 1.1321 2.69238 0.996999 2.34094 1.00005C1.98951 1.00311 1.65333 1.14407 1.40482 1.39258C1.15631 1.64109 1.01534 1.97727 1.01229 2.32871C1.00924 2.68014 1.14433 3.01872 1.38849 3.27152L1.39247 3.27557L7.61079 9.49387L1.39247 15.7122Z",
    fill: "#0D0D0D",
    stroke: "#0D0D0D",
    strokeWidth: 0.653846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.634777570418113c9dbd193cd2946180.svg";
export { ForwardRef as ReactComponent };